import React from "react";
import { useButtonsActions } from "../../hooks/useButtonsActions";
import { useModalTicket } from "../../hooks/useModalTicket";
import ChatIcon from "../../images/attendance.svg";
import EmailIcon from "../../images/email.svg";
import SendIcon from "../../images/send.svg";
import { Button } from "../Button";
import { Subtitle } from "../Subtitle";
import "./styles.scss";

interface Section5Props {}

function Section5({}: Section5Props) {
  const { sendMail, handleAttendance } = useButtonsActions();
  const { toggleModal } = useModalTicket();

  return (
    <section className="section5" id="televendas">
      <div className="row">
        <div className="left col-12 col-md-6 "></div>

        <div className="right col-12 col-md-6">
          <div>
            <Subtitle text="Já fez a sua compra?" />

            <div className="containerInfos">
              <p className="numberMarker">01</p>

              <p>Envie seu boleto para a Koin</p>

              <Button
                text="Enviar Boleto"
                onClick={toggleModal}
                id="envieSeuBoletoTelevendas"
              >
                <img src={SendIcon} alt="Send Icon" />
              </Button>
            </div>

            <div className="containerInfos">
              <p className="numberMarker">02</p>

              <p>Fique tranquilo, a gente entra em contato com você.</p>

              <small>Ficou com alguma dúvida?</small>

              <div className="flex">
                <div className="col mb-3">
                  <Button
                    text="Atendimento"
                    onClick={handleAttendance}
                    id="callTelevendas"
                  >
                    <img src={ChatIcon} alt="Chat Icon" />
                  </Button>
                </div>

                <div className="col mb-3">
                  <Button text="E-mail" onClick={sendMail} id="emailTelevendas">
                    <img src={EmailIcon} alt="Phone Icon" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export { Section5 };
